/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import proptypes from 'prop-types';
import { Button } from '@one-thd/sui-atomic-components';
import {
  QueryProvider, extend, QueryContext
} from '@thd-nucleus/data-sources';
import { VerticalRecsProductPodV7 } from '../vertical-recommendation/VerticalRecsProductPodV7';

const { string: stringType } = proptypes;

const Summary = ({ itemId, storeId }) => {

  const { defaultVariables } = useContext(QueryContext) || {};

  const handleViewProduct = () => {
    window.location.href = `/p/${itemId}`;
  };

  return (
    <QueryProvider
      cacheKey={`summary-${itemId}`}
      dataSource="searchNav"
      defaultVariables={{
        itemId,
        storeId,
        ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean' && {
          isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
        }),
      }}
    >
      <VerticalRecsProductPodV7
        itemId={itemId}
        storeId={storeId}
        scheme="more_like_this"
        anchorProduct={itemId}
        hideATC
        preferredPriceFlag
        onlyReviewCount={false}
        isMerchRecRequired={false}
      />
      <Button
        variant="secondary"
        onClick={handleViewProduct}
        fullWidth
      >
        View Product Details
      </Button>
      <hr className="sui-my-2" />
    </QueryProvider>
  );
};

Summary.propTypes = {
  itemId: stringType.isRequired,
  storeId: stringType.isRequired
};

Summary.displayName = 'Summary';

Summary.dataModel = extend(VerticalRecsProductPodV7);

export { Summary };
